<template>
    <modal-base tenant-state="ringing">
        <template #subtitle>Calling lawyer...</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            // this.$store.commit('card', 'contact');
        }
    }
</script>
